import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { OfferDto } from '@hub-la/sdk-bff-product'
import { inject } from 'inversify'
import { PatchOfferNameInput } from '../../domain/dtos/offers/patch-offer-name'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class PatchOfferName {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: PatchOfferNameInput, signal?: AbortSignal): Promise<OfferDto> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input?.productId}/offers/${input?.offerId}/name`,
      body: {
        name: input?.name,
      },
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }
}
